<!--
 * @Author: 
 * @Date: 
 * @LastEditors: 
 * @LastEditTime: 
 * @Description: file content
 -->
<template>
  <div class="myPrize">
    <div class="prize-circular"></div>
    <div class="prize-bg">
      <div class="cont_tag">
        <p>请持以下获得奖品后方兑换码</p>
        <p>在活动结束 后凭借相关证明直接前往</p>
        <p>对应领奖地址进行兑换。</p>
      </div>
    </div>
    <div class="prize-list">
      <div class="prize-item" v-for="(item,index) in prize_list1" :key="'prize' + index">
        <img
          class="prize-img"
          src="http://assets.rurushishi.com/activies/fortune-cat/prize_icon.png?v=2"
        />
        <div class="prize-name">{{item.prizeName}} {{item.countTime}}</div>
        <div class="prize-btn">
          <template v-if="item.status === 2">
            <div v-if="item.countTime === ''" class="use2">已过期</div>
            <div
              v-else
              @click="receivePrize(item)"
              class="use1"
            >领取</div>
          </template>
          <template v-else>
            <div
              v-if="item.status==3"
              @click="showInfo(item)"
              class="use1"
            >兑换</div>
            <div
              v-if="item.status==4"
              class="use2"
            >已兑换</div>
          </template>
        </div>
      </div>
      <div class="prize-item" v-for="(item,index) in prize_list" :key="index">
        <img
          class="prize-img"
          src="http://assets.rurushishi.com/activies/fortune-cat/prize_icon.png?v=2"
        />
        <div class="prize-name">{{item.orderName}}</div>
        <div class="prize-btn">
          <div
            v-if="item.prizeCodeStatus==1"
            @click="showInfo(item)"
            class="use1"
          >兑换</div>
          <div
            v-if="item.prizeCodeStatus==2"
            class="use2"
          >已兑换</div>
        </div>
      </div>
      <div class="common-nodata" v-if="prize_list.length === 0 && prize_list1.length === 0">
        <div class="zero">
          <div class="zero_top">
            <img src="http://assets.rurushishi.com/activies/online/dtt-purchase/gift_zero.png" alt />
          </div>
          <div class="zero_bottom">
            <p>空空如也，您还没有任何奖品</p>
            <p>快去参加活动领奖品吧～</p>
          </div>
        </div>
      </div>
    </div>
    <BaseBtnHome></BaseBtnHome>
    <!-- 弹窗 -->
    <div class="masks" v-show="showPrize">
      <!-- <div :style="{height: scrollTop}"></div> -->
      <div class="info1">
        <div class="title">奖品详情</div>
        <div class="item">领奖时间: {{time}}</div>
        <div class="item">领奖地址: {{address1}}</div>
        <div class="item">兑换码: {{ code }}</div>
        <span class="sclose" @click="showPrize = false">
          <img
            src="http://assets.rurushishi.com/activies/panda-game/close.png"
            alt
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {},
  data() {
    return {
      prize_list: [],
      prize_list1: [],
      prizeInfo: "",
      showPrize: false,
      code: "",
      address1: "",
      time:"",
      timeStatus: true,
      winnerNum: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    async receivePrize(item) {
      this.timeStatus = false
      this.$modal.drawForm.alert({ prizeId: item.prizeId, isMyprize: true }).then(()=> {
        this.timeStatus = true
        this.getmygiftList()
      })
    },
    //我的礼品列表
    async getmygiftList() {
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/myPrize')
      if (data.code == 0) {
        this.prize_list1 = data.data
        this.prize_list1.forEach((v, i) => {
          v.status === 2 && this.mathTime(i)
        })
      }
      // const data = await this.$httpdf.get(this.apiHost + 'prize/myPrize')
      // if (data.code == 0) {
      //   this.prize_list = data.data;
      // } else if (data.code !== 0) {
      //   this.$showModal(data.msg || "网络不佳，请稍后再试！");
      // }
      // const data1 = await this.$httpdf.get(this.apiHost + 'prize/unPrize')
      // if (data1.code == 0) {
      //   this.prize_list1 = data1.data
      //   this.prize_list1.forEach((v, i) => {
      //     this.mathTime(i)
      //   })
      // }
    },
    mathTime(index) {
      if (!this.timeStatus) {
        return
      }
      if (this.prize_list1[index].countdown > 0) {
        this.$set(this.prize_list1[index],'countTime', --this.prize_list1[index].countdown + 's后过期')
      } else {
        this.prize_list1[index].countTime = ''
        return
      }
      //递归每秒调用mathTime方法，显示动态时间效果
      setTimeout(() => {
        this.mathTime(index)
      }, 1000);
    },
    showInfo(item) {
      console.log(item);
      this.code = item.prizeCode;
      // this.address1 = JSON.parse(item.expandParams)
      this.address1 = item.address
      this.time= '2021年6月16日9:00-2021年6月30日18:00';
      this.showPrize = true;
    }
  },
  destroyed() {
    this.timeStatus = false
  },
  async mounted() {
    this.timeStatus = true
    this.getmygiftList();
  },
};
</script>
<style lang="scss" scoped>
.common-nodata {
  font-size: 14px;
  // font-weight bold;
  text-align: center;
  font-family: PingFang SC;
  margin-top: 20px;
}

.myPrize {
  position: absolute;
  background-color: #F3F3F3;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}

.prize-circular {
  position: absolute;
  width: 575px;
  height: 280px;
  left: -100px;
  top: -115px;
  border-radius: 50%;
  background: linear-gradient(0deg, #7EB8DC, #47C3D7);
}

.prize-bg {
  position: relative;
  z-index: 1;
  width: 375px;
  height: 140px;
  // position: relative;
  // border-bottom-left-radius: 50px;
  // border-bottom-right-radius: 50px;
}

.cont_tag {
  width: 350px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  margin: auto;
  text-align: center;
  line-height: 30px;
  padding-top: 22px;
}

.prize-list {
  width: 345px;
  height: 464px;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  margin: auto;
  margin-top: -10px;
  z-index: 1;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px 0;
}

.prize-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 57px;
  margin: 0 20px;
  border-bottom: 1px solid #f0f0f0;
}

.prize-item:last-child {
  border-bottom: none;
}

.prize-img {
  width: 37px;
  border-radius: 50%;
}

.prize-name {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 37px;
}

.prize-btn {
  width: 66px;
  text-align: center;
}

.use1 {
  width: 50px;
  height: 22px;
  background: linear-gradient(180deg, #47C2D6, #1D65A2);
  border-radius: 11px;
  line-height: 22px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  margin: auto;
}

.use2 {
  width: 50px;
  height: 22px;
  background: linear-gradient(0deg, #ACACAC 0%, #EFEFEF 100%);
  border-radius: 11px;
  line-height: 22px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #6A6A6A;
  margin: auto;
}

.code1 {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 37px;
}

.code2 {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: line-through;
  color: rgba(153, 153, 153, 1);
  line-height: 37px;
}

.zero {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 77px;

  .zero_top {
    width: 356px;
    height: 98px;

    img {
      width: 100%;
      height: 100px;
    }
  }

  .zero_bottom {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(154, 154, 154, 1);
    line-height: 24px;
  }
}

.masks {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .info1 {
    position: relative;
    width: 290px;
    background: #FFFFFF;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;

    .title {
      font-size: 18px;
      color: #D80C18;
      font-family: PingFang SC;
      font-weight: bold;
      text-align: center;
      letter-spacing: 2px;
      margin-bottom: 20px;
    }

    .item {
      font-size: 12px;
      margin-bottom: 30px;
      line-height: 20px;
      width: 270px;
      // border-bottom: 1px solid #E9E9E9;
      align-items: center;
      color: #D80C18;
    }
  }
  .sclose {
    position: absolute;
    top: -40px;
    right: 0px;
    width: 20px;
    height: 20px;

    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>